import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import EntryPickerField from 'presentations/components/entry_picker_field';
import { MAX_SELECTED_REVISIONS } from 'presentations/constants';

const AddStepRevisions = ({ selected }) => {
  return (
    <div className="add-step-revisions">
      <div className="row">
        <div className="columns medium-16 large-12">
          <h2>
            Select Up To { MAX_SELECTED_REVISIONS } Designs
            <span className="entry-count">
              ({ selected.length } / { MAX_SELECTED_REVISIONS } selected)
            </span>
          </h2>
          <p>
            Click on any entry to select or un-select it. You can select up
            to { MAX_SELECTED_REVISIONS } designs for each presentation site.
          </p>
        </div>
      </div>
      <Field name="selected_revisions" component={EntryPickerField} />
    </div>
  );
}

AddStepRevisions.propTypes = {
  selected: PropTypes.array.isRequired,
};

export default AddStepRevisions;



// WEBPACK FOOTER //
// ./presentations/components/add_step_revisions.jsx